import * as React from "react";
const SvgFiBrandsNvidia = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M9.32 8.798v-1.43c.149-.009.295-.018.442-.018 4.086-.124 6.764 3.374 6.764 3.374s-2.89 3.851-5.99 3.851c-.415 0-.82-.062-1.206-.185v-4.346c1.592.185 1.914.857 2.862 2.385l2.126-1.713s-1.556-1.952-4.168-1.952a7 7 0 0 0-.83.034m0-4.734v2.138l.442-.027c5.678-.186 9.386 4.469 9.386 4.469s-4.251 4.964-8.677 4.964c-.387 0-.764-.035-1.14-.097v1.325c.313.035.635.062.947.062 4.122 0 7.103-2.023 9.993-4.407.478.371 2.438 1.263 2.842 1.651-2.741 2.208-9.137 3.984-12.762 3.984-.35 0-.681-.018-1.011-.053v1.864H25V4.064zm0 10.326v1.131c-3.809-.654-4.867-4.461-4.867-4.461s1.831-1.944 4.868-2.262v1.238h-.01C7.72 9.85 6.47 11.281 6.47 11.281s.708 2.411 2.852 3.109m-6.763-3.489S4.811 7.704 9.33 7.368V6.201C4.324 6.59 0 10.653 0 10.653s2.448 6.802 9.32 7.42v-1.237c-5.04-.6-6.763-5.935-6.763-5.935"
    />
  </svg>
);
export default SvgFiBrandsNvidia;
